import { FlowMoments, FlowSteps } from '../models/FlowSteps';

export default class Events {
  static callingModule;
  static init(element) {
    if (!this.callingModule) this.callingModule = element;
  }

  static flowEvent(step: FlowSteps, moment: FlowMoments) {
    const eventName = `ect-${step.toString()}-${moment.toString()}-event`;
    this.callingModule.dispatchEvent(
      new CustomEvent(eventName, {
        detail: {},
        bubbles: true,
        cancelable: true,
        composed: true,
      }),
    );
  }

  static flowStarted() {
    this.callingModule.dispatchEvent(
      new CustomEvent('ect-started', {
        detail: {},
        bubbles: true,
        cancelable: true,
        composed: true,
      }),
    );
  }

  static flowAborted() {
    this.callingModule.dispatchEvent(
      new CustomEvent('ect-aborted', {
        detail: {},
        bubbles: true,
        cancelable: true,
        composed: true,
      }),
    );
  }

  static flowCompleted() {
    this.callingModule.dispatchEvent(
      new CustomEvent('ect-completed', {
        detail: {},
        bubbles: true,
        cancelable: true,
        composed: true,
      }),
    );
  }

  static flowError(error: string) {
    this.callingModule.dispatchEvent(
      new CustomEvent('ect-error', {
        detail: { error },
        bubbles: true,
        cancelable: true,
        composed: true,
      }),
    );
  }

  static tokenExpired() {
    this.callingModule.dispatchEvent(
      new CustomEvent('ect-session-expired', {
        detail: {},
        bubbles: true,
        cancelable: true,
        composed: true,
      }),
    );
  }
}
